import React from 'react';
import PropTypes from 'prop-types';
import { FlightsResultsProviders } from '@edreamsodigeo/frontend-flights-results';
import PrimeResultsProvider from './PrimeResultsProvider';
const FlightResultsProvider = ({
  children,
  ...rest
}) => {
  return /*#__PURE__*/React.createElement(PrimeResultsProvider, null, /*#__PURE__*/React.createElement(FlightsResultsProviders, rest, children));
};
FlightResultsProvider.propTypes = {
  children: PropTypes.node.isRequired
};
export default FlightResultsProvider;